const SEO = [
	{
		page: "home",
		description:
			"I am an aspiring software engineer and project manager with experience using React, Python, JAVA, and C++. I have worked in agile developer environments and am always looking for my next challenge!",
		keywords: ["Samuel", "Samuel K", "Samuel Knorr"],
	},

	{
		page: "about",
		description:
			"I am an aspiring software engineer and project manager with experience using React, Python, JAVA, and C++. I have worked in agile developer environments and am always looking for my next challenge!",
		keywords: ["Samuel", "Samuel K", "Samuel Knorr"],
	},

	{
		page: "projects",
		description:
			"I have worked on many personal, intern, and school projects over the years. Here you can learn about what I did and see the final results.",
		keywords: ["Samuel", "Samuel K", "Samuel Knorr"],
	},

	{
		page: "contact",
		description:
			"If you are interested in reaching out you can find me on LinkedIn or by messaging through email.",
		keywords: ["Samuel", "Samuel K", "Samuel Knorr"],
	},

	{
		page: "capstone",
		description:
			"During my Fall 2024 Semester I completed my engineering capstone project. My team of five worked with the University of Virginia Swim and Dive team to produce a modified diving block. This uses force sensors to measure the force a swimmer dives off with and relays that data to a web app. A video demo and report of this project can be found below.",
		keywords: ["Samuel", "Samuel K", "Samuel Knorr"],
	},
];

export default SEO;
